import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './PumpkinPage.css';
import pumpkinLogo from '../images/pumpkin-logo.png';
import pumpkinDs10 from '../images/pumpkin-ds-10-img.png';
import pumpkinDs63 from '../images/pumpkin-ds-63-img.png';
import pumpkinArjun from '../images/pumpkin-arjun-img.png';

const varieties = [
  {
    name: 'DS-10 ',
    image: pumpkinDs10,
    description: [
      'Days to first picking: 70-80 days after sowing',
      'Fruit colour: Dark green with cream spots',
      'Fruit weight: 7-8 kg',
      'Fruit shape: Oblong to long',
      'Remark: Early maturity',
    ],
  },
  {
    name: 'DS-63 ',
    image: pumpkinDs63,
    description: [
      'Category: Pumpkin (F1 Hybrid)',
      'Days to first picking: 75-78 days after sowing',
      'Fruit colour: Light green',
      'Fruit weight: 3.5-5.5 kg',
      'Fruit shape: Flat round',
      'Remark: Excellent fruit setting',
    ],
  },
  {
    name: 'ARJUN',
    image: pumpkinArjun,
    description: [
      'One of the most popular varieties; suitable for harvesting at immature green stage or fully mature red-brown stage based on market demand.',
      'Mature fruits have very good shelf life and this variety has proven to be an extremely high yielder.',
      'Type/Fruit type: Flat round smooth.',
      'Maturity days: 90-95 days.',
      'Fruit weight: 3-4 kg.',
      'Plant type: Strong vigorous plant.',
      'Fruit colour: Dark green skin at immature stage, turning smooth yellowish orange on ripening.',
      'Others: Yellowish orange flesh, firm and sticky texture, with excellent taste.',
    ],
  },
 
];

export default function PumpkinPage() {
  return <ProductPatternPage title="Pumpkin" varieties={varieties} pageClass="pumpkin-page" heroImage={pumpkinLogo} />;
}
